import { useEffect } from "react";
import { scroller } from "react-scroll/modules";
import useReactRouter from "use-react-router";

export default function useScrollTo(id) {
  const { location } = useReactRouter();

  useEffect(() => {
    /**
     * The element to scroll to has the same id but is located in the StepHeader
     */
    if (location.state && location.state.scrollIntoView) {
      scroller.scrollTo(id, {
        isDynamic: true,
        smooth: true,
        delay: 100,
        duration: 300
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
